import { FaCheck, FaMinus } from "react-icons/fa";
import Eyebrow from "../common/Eyebrow";

const PLANS = [
  { key: "colocation", name: "Colocation", highlight: false },
  { key: "dedicated", name: "Dedicated Servers", highlight: true },
  { key: "cloud", name: "Cloud Hosting", highlight: false },
  { key: "vps", name: "VPS", highlight: false },
];

const ROWS = [
  { label: "You own the hardware", colocation: true, dedicated: false, cloud: false, vps: false },
  { label: "Fully managed by QuantaRock", colocation: false, dedicated: true, cloud: true, vps: true },
  { label: "Dedicated physical resources", colocation: true, dedicated: true, cloud: false, vps: false },
  { label: "Instantly scalable", colocation: false, dedicated: false, cloud: true, vps: true },
  { label: "Best for", colocation: "Custom hardware", dedicated: "High-traffic apps", cloud: "Variable workloads", vps: "Small-mid projects" },
];

const Cell = ({ value }) => {
  if (typeof value === "string") {
    return <span className="text-sm text-slate-600">{value}</span>;
  }
  return value ? (
    <FaCheck className="mx-auto text-[var(--website-secondary-color)]" size={14} />
  ) : (
    <FaMinus className="mx-auto text-slate-300" size={12} />
  );
};

const ComparisonTable = () => {
  return (
    <section className="bg-white px-6 py-20">
      <div className="mx-auto max-w-5xl">
        <div className="text-center">
          <Eyebrow>Compare</Eyebrow>
        </div>
        <h2 className="mx-auto mt-3 max-w-2xl text-center text-3xl font-bold tracking-tight text-[var(--website-primary-color)] md:text-4xl">
          Find the right hosting model
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center leading-relaxed text-slate-600">
          Every plan runs on the same Tier-3 facilities and 24/7 NOC support
          — the difference is who manages what.
        </p>

        <div className="mt-10 overflow-x-auto rounded-2xl border border-slate-200">
          <table className="w-full min-w-[640px] border-collapse text-left">
              <thead>
                <tr className="border-b border-slate-200 bg-slate-50">
                  <th className="p-4 text-sm font-semibold text-slate-500">
                    Feature
                  </th>
                  {PLANS.map((plan) => (
                    <th
                      key={plan.key}
                      className={`p-4 text-center text-sm font-semibold ${
                        plan.highlight
                          ? "bg-[rgba(var(--website-secondary-rgb),0.1)] text-[var(--website-primary-color)]"
                          : "text-[var(--website-primary-color)]"
                      }`}
                    >
                      {plan.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ROWS.map((row, i) => (
                  <tr
                    key={row.label}
                    className={i !== ROWS.length - 1 ? "border-b border-slate-100" : ""}
                  >
                    <td className="p-4 text-sm font-medium text-[var(--website-primary-color)]">
                      {row.label}
                    </td>
                    {PLANS.map((plan) => (
                      <td
                        key={plan.key}
                        className={`p-4 text-center ${
                          plan.highlight ? "bg-[rgba(var(--website-secondary-rgb),0.05)]" : ""
                        }`}
                      >
                        <Cell value={row[plan.key]} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;
